import { PropsWithChildren, useMemo } from 'react';
import { InboxDetailsContext, InboxDetailsContextType } from './index';
import { useAppContext } from 'src/contexts/AppContext';
import { useInboxDetailsQuery } from 'src/api/inboxes';
import { useParams } from 'react-router-dom';

export function InboxDetailsContextProvider(props: PropsWithChildren) {
  const { currentCustomer } = useAppContext();
  const { id: messageId } = useParams();
  const {
    data: message,
    isLoading,
    isError,
  } = useInboxDetailsQuery(
    currentCustomer?.customerName ?? 'missing_customer',
    messageId ?? '',
  );

  const value = useMemo<InboxDetailsContextType>(
    () => ({ message, isLoading, isError }),
    [isError, isLoading, message],
  );

  return (
    <InboxDetailsContext.Provider value={value}>
      {props.children}
    </InboxDetailsContext.Provider>
  );
}
